module.exports = __webpack_public_path__ + "static/media/empty-state-crew.6f7c432a.svg";